"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayAlertCenterEntity = exports.DisplayAlertPageEntity = exports.DisplayAlertBreakdownEntity = exports.DisplayAlertTrendPointEntity = exports.DisplayAlertSummaryEntity = exports.DisplayAlertEntity = exports.DisplayAlertEvidenceEntity = exports.DisplayAlertDisplayEntity = exports.DISPLAY_ALERT_SEVERITIES = exports.DISPLAY_ALERT_STATUSES = exports.DISPLAY_ALERT_KINDS = void 0;
exports.DISPLAY_ALERT_KINDS = [
    "scheduled_disconnect",
    "long_operational_inactivity",
    "unexpected_power_state",
    "connection_flapping",
    "delivery_failure",
    "missing_telemetry",
    "incomplete_schedule",
    "outside_schedule_playback",
];
exports.DISPLAY_ALERT_STATUSES = ["active", "recovered"];
exports.DISPLAY_ALERT_SEVERITIES = ["info", "warning", "critical"];
class DisplayAlertDisplayEntity {
    id;
    ref;
    name;
    timeZone;
    schedule;
    ownerId;
    providerId;
    categoryId;
    tagIds;
}
exports.DisplayAlertDisplayEntity = DisplayAlertDisplayEntity;
class DisplayAlertEvidenceEntity {
    eventId;
    timestamp;
    category;
    type;
    severity;
    source;
    hasScreenshot;
    mediaId;
    mediaCampaignId;
    playlistId;
    reason;
}
exports.DisplayAlertEvidenceEntity = DisplayAlertEvidenceEntity;
class DisplayAlertEntity {
    id;
    kind;
    status;
    severity;
    display;
    startedAt;
    lastObservedAt;
    recoveredAt;
    durationSeconds;
    occurrenceCount;
    confidence;
    lastConnectionAt;
    operatingDaysMissed;
    evaluatedOperatingDates;
    currentScheduleEndsAt;
    mediaId;
    mediaCampaignId;
    playlistId;
    reason;
    evidence;
}
exports.DisplayAlertEntity = DisplayAlertEntity;
class DisplayAlertSummaryEntity {
    publishedDisplays;
    evaluatedDisplays;
    connectedDisplays;
    disconnectedDisplays;
    criticalActive;
    warningActive;
    infoActive;
    recovered;
    deliveryFailures;
    expectedSeconds;
    connectedSeconds;
    missedSeconds;
    availabilityPercent;
    dataCoveragePercent;
    unavailableDisplays;
}
exports.DisplayAlertSummaryEntity = DisplayAlertSummaryEntity;
class DisplayAlertTrendPointEntity {
    bucketStart;
    total;
    critical;
    warning;
    info;
}
exports.DisplayAlertTrendPointEntity = DisplayAlertTrendPointEntity;
class DisplayAlertBreakdownEntity {
    kind;
    count;
}
exports.DisplayAlertBreakdownEntity = DisplayAlertBreakdownEntity;
class DisplayAlertPageEntity {
    results;
    total;
    page;
    limit;
}
exports.DisplayAlertPageEntity = DisplayAlertPageEntity;
class DisplayAlertCenterEntity {
    generatedAt;
    period;
    warnings;
    summary;
    trend;
    breakdown;
    alerts;
}
exports.DisplayAlertCenterEntity = DisplayAlertCenterEntity;
